import React from 'react';
import styles from './WrappedText.module.scss';

type Props = {
    children: React.ReactNode | string;
    monospace?: boolean;
    preserve?: boolean;
    wrap?: boolean;
    className?: string;
    style?: React.CSSProperties;
};

export default function WrappedText({
    children,
    monospace = true,
    preserve = true,
    wrap = true,
    className = '',
    style,
}: Props) {
    const containerClass = [styles.container, className].filter(Boolean).join(' ');

    const contentStyle: React.CSSProperties = {
        fontFamily: monospace
            ? 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Roboto Mono", "Segoe UI Mono", monospace'
            : undefined,
        whiteSpace: preserve ? 'pre-wrap' : wrap ? 'normal' : 'nowrap',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
        ...style,
    };

    return (
        <div className={containerClass}>
            <div className={styles.content} style={contentStyle}>
                {children}
            </div>
        </div>
    );
}
